import * as React from "react";
import Button from "../../../../../widgets/button";
import CustomLink from "../../../../../widgets/link";
import { NavigationBarProps } from "./types";
import "./styles.scss";
import { useFeatureToggles } from "../../../../../../pages/shared/hooks/useFeatureToggles";
import { Feature } from "../../../../../../context/types";

const classNameBase = "scd-navigation-bar";

export default function NavigationBar({
  onCancel,
  onNext,
  onBack,
  isSubmitting,
  onAdditionalAction,
  backButtonText,
  nextButtonText,
  cancelButtonText,
  additionalActionText,
}: NavigationBarProps): React.JSX.Element {
  const canCancelApplication = useFeatureToggles(Feature.CANCEL_APPLICATION);

  const nextButton = (
    <div className="scd-button-primary-wrapper">
      <Button
        kind="primary"
        data-testid="submit-button"
        disabled={isSubmitting}
        onClick={onNext}
      >
        {nextButtonText}
      </Button>
    </div>
  );

  const additionalAction = (
    <CustomLink onClick={onAdditionalAction}>{additionalActionText}</CustomLink>
  );

  const renderForward = () => {
    if (onAdditionalAction && onNext) {
      return (
        <div className={`${classNameBase}-wrapper-right`}>
          {additionalAction}
          {nextButton}
        </div>
      );
    }
    if (onAdditionalAction) {
      return additionalAction;
    }
    if (onNext) {
      return nextButton;
    }

    return null;
  };

  const renderBackwardOrCancelAsSecondary = () => {
    const hasBackButton = !!onBack;
    const hasCancelButton = !!onCancel;
    if (hasBackButton) {
      return (
        <Button kind="secondary" onClick={onBack}>
          {backButtonText}
        </Button>
      );
    } else if (hasCancelButton && canCancelApplication) {
      return (
        <Button kind="secondary" onClick={onCancel}>
          {cancelButtonText}
        </Button>
      );
    }
  };

  const renderCancelAsLink = () => {
    const hasBackButton = !!onBack;
    const hasCancelButton = !!onCancel;
    if (canCancelApplication && hasBackButton && hasCancelButton) {
      return <CustomLink onClick={onCancel}>{cancelButtonText}</CustomLink>;
    }
  };

  return (
    <>
      <div className={classNameBase}>
        {renderBackwardOrCancelAsSecondary()}
        {renderForward()}
      </div>
      <div className={`${classNameBase}-cancel`}>{renderCancelAsLink()}</div>
    </>
  );
}
